var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/create-hash@1.2.0/~/create-hash/md5.js
// module id = 271
// module chunks = 0